import commonStyles from '../styles.module.scss'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import {Text, Button} from 'common/components'
import {useAcceptRequestStatus, isMilestonePassed, CheckActionsProps} from '..'

export default function CoordinatorCheckActions({
  role,
  request,
  isRequestLoading,
}: CheckActionsProps) {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const {
    mutate: acceptRequestStatus,
    isMutating: isAcceptRequestStatusMutating,
  } = useAcceptRequestStatus(request.uuid)

  const setManagerAssignOpen = useStore((state) => state.setManagerAssignOpen)

  const isChecked = isMilestonePassed('manager-assigned', request)

  const handleClick = () =>
    isChecked ? acceptRequestStatus() : setManagerAssignOpen(true)

  const actionText = isChecked ? 'confirm' : 'assign'

  return (
    <div className={commonStyles.checkActions}>
      <Text size="xs">
        <Text as="span" weight="demiBold">
          Loans coordinator
        </Text>{' '}
        needs to {actionText} Lending manager
      </Text>
      { !!permissions?.includes('edit loan request (lc check)') && (
        <Button
          disabled={isRequestLoading}
          loading={isAcceptRequestStatusMutating}
          onClick={handleClick}
        >
          {actionText} manager
        </Button>
      )}
    </div>
  )
}
